import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['password', 'show'];

    connect() {
        this.hide();
    }

    disconnect() {
        this.hide();
    }

    toggle() {
        if (this.passwordVisible) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        this.passwordTarget.type = 'text';
        this.passwordVisible = true;
        if (this.hasShowTarget) {
            this.showTarget.classList.remove('opacity-100');
            this.showTarget.classList.add('opacity-50');
        }
    }

    hide() {
        this.passwordTarget.type = 'password';
        this.passwordVisible = false;
        if (this.hasShowTarget) {
            this.showTarget.classList.remove('opacity-50');
            this.showTarget.classList.add('opacity-100');
        }
    }
}
